export interface PlayerIdentityRecord {
  userId?: string | null;
  playerConstructId?: string | null;
}

export const getPlayerIdentityKey = (
  record: PlayerIdentityRecord
): string | null => {
  if (record.userId) return `user:${record.userId}`;
  if (record.playerConstructId) {
    return `construct:${record.playerConstructId}`;
  }
  return null;
};

export const getPlayerIdentityInput = (identityKey: string) => {
  if (identityKey.startsWith("user:")) {
    return { userId: identityKey.slice("user:".length) };
  }
  if (identityKey.startsWith("construct:")) {
    return {
      playerConstructId: identityKey.slice("construct:".length),
    };
  }
  throw new Error("Unknown player identity.");
};

export const getPlayerDisplayName = (
  record: PlayerIdentityRecord,
  users: any[],
  constructs: any[]
): string => {
  if (record.userId) {
    const user = users.find((candidate) => candidate.id === record.userId);
    if (user) return user.displayName || user.username || "Unknown player";
  }
  if (record.playerConstructId) {
    const construct = constructs.find(
      (candidate) => candidate.id === record.playerConstructId
    );
    if (construct) return construct.name || "Unknown player";
  }
  return "Unknown player";
};
